module.exports = __webpack_public_path__ + "static/media/sequelize.072e8542.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Skills/images/sequelize.png
// module id = 124
// module chunks = 0